// extracted by mini-css-extract-plugin
export default {"easterEggButton":"EasterEggButton_easterEggButton__M2XQ+"};